import { useTransition } from "react";

export type DuoSkinToggleProps = {
  duoEnabled: boolean;
  disabled?: boolean;
  onChange: (next: boolean) => void;
};

/**
 * In-session toggle for the DUO real-exam chrome. Same shape as FeedbackToggle.
 */
export function DuoSkinToggle({
  duoEnabled,
  disabled = false,
  onChange,
}: DuoSkinToggleProps) {
  const [pending, startTransition] = useTransition();

  function set(next: boolean) {
    if (disabled || pending) return;
    if (next === duoEnabled) return;
    onChange(next);
    startTransition(() => {});
  }

  const segmentBase =
    "inline-flex h-8 sm:h-10 items-center rounded-full px-3 sm:px-4 text-xs sm:text-sm focus-visible:[border-radius:9999px] transition-colors";
  const segmentActive = `${segmentBase} bg-[var(--accent)] font-semibold text-[var(--bg)]`;
  const segmentIdle = `${segmentBase} text-[var(--ink-muted)] hover:bg-[var(--accent-soft)] hover:text-[var(--ink)]`;

  return (
    <div
      role="group"
      aria-label="DUO-simulatie"
      aria-disabled={disabled || undefined}
      className={`inline-flex items-center rounded-full border border-[var(--border)] bg-[var(--panel-soft)] p-1 ${disabled ? "opacity-50" : ""}`}
    >
      <button
        type="button"
        onClick={() => set(true)}
        aria-pressed={duoEnabled}
        disabled={disabled}
        className={duoEnabled ? segmentActive : segmentIdle}
      >
        Aan
      </button>
      <button
        type="button"
        onClick={() => set(false)}
        aria-pressed={!duoEnabled}
        disabled={disabled}
        className={!duoEnabled ? segmentActive : segmentIdle}
      >
        Uit
      </button>
    </div>
  );
}
